'use client';

export { default } from './ListItemAvatar';
export { default as listItemAvatarClasses } from './listItemAvatarClasses';
export * from './listItemAvatarClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/ListItemAvatar/index.js
// module id = 861
// module chunks = 22